// Deleted tables are normally hidden, but a deleted table that still has an open
// cheque must stay visible, otherwise staff can't reach (and close) that cheque.

/**
 * Builds a predicate that returns true for tables that should be shown:
 * every non-deleted table, plus deleted tables that still have a cheque on them.
 */
export function makeIsTableVisible(cheques: { tableId?: string | null }[]) {
  const tableIdsWithCheques = new Set(cheques.map((cheque) => cheque.tableId).filter(Boolean));

  return (table: { id: string; deleted: boolean }) =>
    !table.deleted || tableIdsWithCheques.has(table.id);
}
